import { apiPost, defaultErrorCallback, ErrorCallback, SuccessCallback } from 'api/api';
import { BookingOnLoadReqConfig } from 'entities/Form';
import type {
  BookingOnLoadResV2,
  GetAvailableTimeSlotsDetailReqConfigV2,
  GetAvailableTimeSlotsDetailResV2,
  GetAvailableTimeSlotsReqConfigV2,
  GetAvailableTimeSlotsResV2,
} from 'entities/FormV2';
import i18n from 'i18next';
import { getApiLangParam } from 'utils/helper';

export const bookingOnLoadV2 = (
  config: BookingOnLoadReqConfig,
  onSuccess: SuccessCallback<BookingOnLoadResV2>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void,
) =>
  apiPost('/bookingOnLoad2', { lang: getApiLangParam(i18n.language), ...config }, onSuccess, onError, finallyCallback);

export const getAvailableTimeSlotsV2 = (
  config: GetAvailableTimeSlotsReqConfigV2,
  onSuccess: SuccessCallback<GetAvailableTimeSlotsResV2>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void,
) => {
  const { masterServiceItemHid, careProviderHids, fromDt, toDt } = config;

  return apiPost(
    '/getAvailableTimeSlotsByServiceItemMaster',
    {
      masterServiceItemHid,
      careProviderHids,
      fromDt,
      toDt,
    },
    (res: GetAvailableTimeSlotsResV2) => onSuccess({ ...res, timeSlotDictionary: res.timeSlotDictionary || {} }),
    onError,
    finallyCallback,
  );
};

export const getAvailableTimeSlotsDetailV2 = (
  config: GetAvailableTimeSlotsDetailReqConfigV2,
  onSuccess: SuccessCallback<GetAvailableTimeSlotsDetailResV2>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void,
) => {
  const { masterServiceItemHid, careProviderHid, fromDt } = config;

  return apiPost(
    '/getAvailableTimeSlotsDetailByServiceItemMaster',
    { masterServiceItemHid, careProviderHid, fromDt },
    onSuccess,
    onError,
    finallyCallback,
  );
};
